(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    const page = document.querySelector('[data-collection-page]');
    if (!page || page.dataset.infiniteReady) return;
    page.dataset.infiniteReady = 'true';
    const loadMore = page.querySelector('[data-load-more]');
    const grid = page.querySelector('[data-collection-grid]');
    const wrap = page.querySelector('[data-load-more-wrap]');
    const status = page.querySelector('[data-load-status]');
    if (!loadMore || !grid || !wrap) return;

    let loading = false;
    const fetchNext = async () => {
      if (loading || !loadMore.href) return;
      loading = true;
      loadMore.classList.add('is-loading');
      loadMore.textContent = 'Loading…';
      try {
        const response = await fetch(loadMore.href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error('Unable to load more products');
        const html = await response.text();
        const nextPage = new DOMParser().parseFromString(html, 'text/html');
        const nextGrid = nextPage.querySelector('[data-collection-grid]');
        const nextLink = nextPage.querySelector('[data-load-more]');
        if (nextGrid) grid.insertAdjacentHTML('beforeend', nextGrid.innerHTML);
        if (nextLink) {
          loadMore.href = nextLink.href;
          loadMore.textContent = 'Load more styles';
        } else {
          wrap.remove();
        }
      } catch (error) {
        loadMore.textContent = 'Load more styles';
        if (status) status.textContent = 'Could not load more styles. Try again.';
      } finally {
        loading = false;
        loadMore.classList.remove('is-loading');
      }
    };
    const observer = new IntersectionObserver((entries) => { if (entries[0].isIntersecting) fetchNext(); }, { rootMargin: '500px 0px' });
    observer.observe(wrap);
    loadMore.addEventListener('click', (event) => { event.preventDefault(); fetchNext(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  function initializeCollectionTabs(root) {
    const tabs = Array.from(root.querySelectorAll('[data-collection-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-collection-panel]'));
    const viewAll = root.querySelector('[data-collection-view-all]');
    const previous = root.querySelector('[data-collection-prev]');
    const next = root.querySelector('[data-collection-next]');
    if (!tabs.length) return;

    const activePanel = () => panels.find((panel) => !panel.hidden);
    const updateArrows = () => {
      const panel = activePanel();
      const hasOverflow = panel && panel.scrollWidth > panel.clientWidth + 1;
      if (previous) previous.hidden = !hasOverflow;
      if (next) next.hidden = !hasOverflow;
    };
    const scrollProducts = (direction) => {
      const panel = activePanel();
      if (!panel) return;
      const target = Math.max(0, Math.min(panel.scrollWidth - panel.clientWidth, panel.scrollLeft + direction * panel.clientWidth * 0.85));
      panel.scrollTo({left: target, behavior: 'smooth'});
    };
    if (previous) previous.addEventListener('click', () => scrollProducts(-1));
    if (next) next.addEventListener('click', () => scrollProducts(1));

    function staggerCards(panel) {
      const cards = panel.querySelectorAll('.product-card');
      cards.forEach((card, i) => {
        card.classList.remove('is-visible');
        setTimeout(() => card.classList.add('is-visible'), 60 * i);
      });
    }

    const activate = (activeTab) => {
      tabs.forEach((tab) => {
        const selected = tab === activeTab;
        tab.classList.toggle('is-active', selected);
        tab.setAttribute('aria-selected', String(selected));
      });
      panels.forEach((panel) => {
        const isActive = panel.id === activeTab.getAttribute('aria-controls');
        panel.hidden = !isActive;
        if (isActive) staggerCards(panel);
      });
      if (viewAll && activeTab.dataset.collectionUrl) {
        viewAll.href = activeTab.dataset.collectionUrl;
        viewAll.classList.remove('is-disabled');
      }
      updateArrows();
    };

    let arrowTicking = false;
    const requestUpdateArrows = () => {
      if (arrowTicking) return;
      arrowTicking = true;
      requestAnimationFrame(() => {
        updateArrows();
        arrowTicking = false;
      });
    };

    tabs.forEach((tab) => tab.addEventListener('click', () => activate(tab)));
    if (window.ResizeObserver) new ResizeObserver(requestUpdateArrows).observe(root);
    window.addEventListener('resize', requestUpdateArrows, { passive: true });
    // Defer arrow calculation to idle time
    if ('requestIdleCallback' in window) {
      requestIdleCallback(updateArrows, { timeout: 2000 });
    } else {
      setTimeout(updateArrows, 500);
    }
  }

  document.querySelectorAll('[data-collection-tabs]').forEach(initializeCollectionTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.querySelector('.product-reviews');
    if (!section || section.dataset.ready) return;
    section.dataset.ready = 'true';

    const btn = section.querySelector('[data-reviews-show-more]');
    const grid = section.querySelector('[data-reviews-grid]');
    if (btn && grid) {
      const BATCH = 6;
      let shown = grid.querySelectorAll('[data-review-card]:not(.is-hidden)').length;
      const total = grid.querySelectorAll('[data-review-card]').length;
      const remaining = section.querySelector('[data-reviews-remaining]');

      btn.addEventListener('click', () => {
        const cards = grid.querySelectorAll('[data-review-card].is-hidden');
        let count = 0;
        for (const card of cards) {
          if (count >= BATCH) break;
          card.classList.remove('is-hidden');
          count++;
          shown++;
        }
        const left = total - shown;
        if (left <= 0) {
          btn.style.display = 'none';
        } else if (remaining) {
          remaining.textContent = `(${left})`;
        }
      });
    }

    const modal = document.getElementById('review-media-modal');
    const modalContent = document.getElementById('review-media-modal-content');
    if (modal && modalContent) {
      section.addEventListener('click', (e) => {
        if (e.target.matches('.product-review__media img')) {
          modalContent.innerHTML = '';
          const clone = e.target.cloneNode(true);
          modalContent.appendChild(clone);
          modal.showModal();
        }
      });
      modal.addEventListener('click', (e) => {
        if (e.target === modal) modal.close();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const page = document.querySelector('.product-page');
    if (!page || page.dataset.ready) return;
    page.dataset.ready = 'true';

    // Gallery carousel & thumbnails
    const gallery = page.querySelector('[data-gallery]');
    if (gallery) {
      const track = gallery.querySelector('[data-gallery-track]');
      const slides = gallery.querySelectorAll('[data-gallery-slide]');
      const dots = gallery.querySelectorAll('[data-gallery-dot]');
      const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      const mainSlides = gallery.querySelectorAll('[data-gallery-main-slide]');

      // Mobile carousel dot tracking
      if (track && slides.length && dots.length) {
        const updateDots = () => {
          const scrollLeft = track.scrollLeft;
          const slideWidth = slides[0].offsetWidth;
          const currentIndex = Math.round(scrollLeft / slideWidth);
          dots.forEach((dot, i) => dot.classList.toggle('is-active', i === currentIndex));
        };
        track.addEventListener('scroll', updateDots, { passive: true });
        dots.forEach((dot, i) => {
          dot.addEventListener('click', () => {
            slides[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          });
        });
      }

      // Desktop thumbnail clicks
      if (thumbs.length && mainSlides.length) {
        thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => {
            const index = thumb.dataset.galleryThumb;
            thumbs.forEach(t => t.classList.remove('is-active'));
            mainSlides.forEach(s => s.classList.remove('is-active'));
            thumb.classList.add('is-active');
            mainSlides[index]?.classList.add('is-active');
          });
        });
      }
    }

    // Description toggle
    const desc = page.querySelector('[data-description]');
    if (desc) {
      const toggle = desc.querySelector('[data-description-toggle]');
      const content = desc.querySelector('[data-description-content]');
      if (toggle && content) {
        const isOverflowing = content.scrollHeight > content.offsetHeight;
        if (!isOverflowing) {
          toggle.style.display = 'none';
        } else {
          toggle.addEventListener('click', () => {
            desc.classList.toggle('is-expanded');
            toggle.textContent = desc.classList.contains('is-expanded') ? 'Read less' : 'Read more';
          });
        }
      }
    }

    // Product form logic
    const form = page.querySelector('.product-form');
    const variantSelect = page.querySelector('#Product-Variant');
    const optionGroups = [...page.querySelectorAll('[data-option-index]')].filter(g => g.querySelectorAll('[data-option-value]').length > 0);
    const whatsappLink = page.querySelector('[data-whatsapp-link]');
    const variantError = page.querySelector('[data-variant-error]');
    const buyNowWrap = page.querySelector('.shopify-payment-button');
    const selected = optionGroups.map(() => null);
    /* Set once the shopper attempts Add to Bag / Buy Now with missing options —
       error markers only ever render after an attempt, never on page load. */
    let variantAttempted = false;

    const variantComplete = () => !selected.some((value) => !value);

    /* WhatsApp button — prefilled sizing enquiry. Includes the colour when a
       colour option has been selected. */
    const syncWhatsApp = () => {
      if (!whatsappLink) return;
      const title = whatsappLink.dataset.productTitle || '';
      const colourIndex = optionGroups.findIndex((group) => group.dataset.optionType === 'colour');
      const colour = colourIndex >= 0 ? selected[colourIndex] : null;
      const message = `i want to discuss the sizing for this product: ${title}${colour ? `, colour: ${colour}` : ''}`;
      whatsappLink.href = `https://wa.me/919530840375?text=${encodeURIComponent(message)}`;
    };

    const clearVariantError = () => {
      optionGroups.forEach((group) => {
        group.classList.remove('is-invalid');
        const groupError = group.querySelector('[data-option-error]');
        if (groupError) groupError.hidden = true;
      });
      if (variantError) variantError.hidden = true;
    };

    /* Buy Now is never disabled — when variant options are missing it shows
       an error state (icon + message beside each option group) instead of
       submitting with the default variant. */
    const showVariantError = () => {
      const missing = optionGroups.filter((group, index) => !selected[index]);
      missing.forEach((group) => {
        group.classList.add('is-invalid');
        const groupError = group.querySelector('[data-option-error]');
        if (groupError) {
          const text = groupError.querySelector('[data-option-error-text]');
          if (text) text.textContent = `Please select a ${group.dataset.optionType || 'option'}`;
          groupError.hidden = false;
        }
      });
      if (variantError) {
        const names = missing.map((group) => group.dataset.optionType || 'option');
        variantError.textContent = names.length > 1
          ? `Please select ${names.join(' and ')} to continue`
          : `Please select a ${names[0]} to continue`;
        variantError.hidden = false;
      }
    };

    /* Re-renders error markers after each selection change: groups that are
       now selected clear, groups still missing keep their error — but only
       if the shopper already attempted to buy. */
    const refreshVariantError = () => {
      clearVariantError();
      if (variantAttempted) showVariantError();
    };

    if (form && variantSelect && optionGroups.length) {
      let variants = [];
      try { variants = JSON.parse(form.dataset.variants || '[]'); } catch (error) { variants = []; }

      /* Option values per variant, aligned to the rendered option groups.
         variant.options is only trustworthy when it has one entry per group —
         some catalogs store combined values like "Marigold Yellow / XS" in a
         single option, so fall back to splitting the variant title exactly the
         way the buttons were built (first part = colour, last part = size). */
      const optionsOf = (variant) => {
        const fromOptions = Array.isArray(variant.options) ? variant.options.map((opt) => String(opt).trim()) : [];
        if (fromOptions.length >= optionGroups.length) return fromOptions;
        return (variant.title || '').split(' / ').map((part) => part.trim());
      };

      /* The variant matching the full current selection (any availability). */
      const findMatchingVariant = () => {
        if (!variantComplete()) return null;
        return variants.find((variant) => {
          const opts = optionsOf(variant);
          return optionGroups.every((group, index) => opts[index] === selected[index]);
        }) || null;
      };

      const syncVariant = () => {
        optionGroups.forEach((group, index) => {
          const label = group.querySelector('[data-selected-label]');
          if (label) label.textContent = selected[index] || group.dataset.defaultLabel || '';
          group.querySelectorAll('[data-option-value]').forEach((button) => {
            const value = button.dataset.optionValue;
            button.classList.toggle('is-selected', selected[index] === value);
            button.disabled = false;
            button.classList.remove('is-unavailable');
            button.removeAttribute('aria-disabled');
          });
        });

        const match = findMatchingVariant();
        variantSelect.setCustomValidity(match ? '' : 'Please select all options to continue');
        if (match) variantSelect.value = String(match.id);
        refreshVariantError();
        syncWhatsApp();
      };

      optionGroups.forEach((group, index) => {
        group.querySelectorAll('[data-option-value]').forEach((button) => {
          button.addEventListener('click', () => {
            if (button.disabled) return;
            const value = button.dataset.optionValue;
            /* Clicking the active option again deselects it. */
            selected[index] = selected[index] === value ? null : value;
            syncVariant();
          });
        });
      });

      /* The accelerated checkout button lives inside a <shopify-accelerated-checkout>
         custom element (Shadow DOM), so clicks are retargeted to its host. Intercept
         on the .shopify-payment-button wrapper instead — a missing selection then
         surfaces an error instead of checking out the default variant. */
      if (buyNowWrap) {
        page.addEventListener('click', (event) => {
          if (!buyNowWrap.contains(event.target) || variantComplete()) return;
          event.preventDefault();
          event.stopPropagation();
          variantAttempted = true;
          showVariantError();
        }, true);
      }

      /* Suppress the browser's native validation bubble on the hidden select —
         our inline error states already communicate the missing options. */
      variantSelect.addEventListener('invalid', (event) => event.preventDefault());

      async function submitToDrawer(event) {
        if (!window.CartDrawer) return;
        event.preventDefault();
        const submitBtn = form.querySelector('[data-add-to-bag]');
        const originalText = submitBtn ? submitBtn.textContent : 'Add to bag';
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Adding to bag...';
        }

        try {
          const formData = new FormData(form);
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData
          });

          if (!res.ok) {
            const errData = await res.json().catch(() => ({}));
            throw new Error(errData.description || 'Could not add to bag');
          }

          if (submitBtn) {
            submitBtn.textContent = 'Added to bag! ✓';
            setTimeout(() => {
              submitBtn.disabled = false;
              submitBtn.textContent = originalText;
            }, 1000);
          }

          window.CartDrawer.refresh(true);
        } catch (err) {
          console.error('Cart add error:', err);
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
          }
          if (variantError) {
            variantError.textContent = err.message || 'Error adding item to bag. Please try again.';
            variantError.hidden = false;
          }
        }
      }

      form.addEventListener('submit', (event) => {
        if (!variantComplete()) {
          event.preventDefault();
          variantAttempted = true;
          showVariantError();
          return;
        }
        submitToDrawer(event);
      });

      syncVariant();
    } else if (form) {
      syncWhatsApp();
      form.addEventListener('submit', async (event) => {
        if (!window.CartDrawer) return;
        event.preventDefault();
        const submitBtn = form.querySelector('[data-add-to-bag]');
        const originalText = submitBtn ? submitBtn.textContent : 'Add to bag';
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Adding to bag...';
        }
        try {
          const formData = new FormData(form);
          const res = await fetch('/cart/add.js', { method: 'POST', body: formData });
          if (!res.ok) throw new Error('Could not add to bag');
          if (submitBtn) {
            submitBtn.textContent = 'Added to bag! ✓';
            setTimeout(() => {
              submitBtn.disabled = false;
              submitBtn.textContent = originalText;
            }, 1000);
          }
          window.CartDrawer.refresh(true);
        } catch (err) {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
          }
        }
      });
    }
    const deliveryForm = page.querySelector('[data-delivery-form]');
    if (deliveryForm) deliveryForm.addEventListener('submit', (event) => { event.preventDefault(); const pin = deliveryForm.querySelector('input').value; const result = deliveryForm.querySelector('[data-delivery-result]'); if (/^\d{6}$/.test(pin)) { const deliveryDate = new Date(); deliveryDate.setDate(deliveryDate.getDate() + 5); const formattedDate = new Intl.DateTimeFormat('en-IN', { weekday: 'long', day: 'numeric', month: 'long' }).format(deliveryDate); result.textContent = `Delivery by ${formattedDate} · Free shipping · Dispatches within 24 hours`; } else result.textContent = 'Enter a valid 6-digit PIN code to check delivery.'; });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-atc"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const stickyAtc = document.querySelector('[data-sticky-atc]');
    const stickyBtn = document.querySelector('[data-sticky-add]');
    const form = document.querySelector('.product-form');
    
    if (stickyAtc && form) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting && entry.boundingClientRect.bottom < 0) {
            stickyAtc.classList.add('is-visible');
          } else {
            stickyAtc.classList.remove('is-visible');
          }
        });
      }, { threshold: 0 });
      
      observer.observe(form);
      
      if (stickyBtn) {
        stickyBtn.addEventListener('click', () => {
          form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
